import { isUserLoggedIn } from '../../utils/authUtils';
import { getPartialModel } from '../../utils/modelUtils';
import { CrudServiceBaseTransformed } from '../base/crudServiceBaseTransformed';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { InsuranceCompanyDto } from './insuranceCompanyDto';

export class InsuranceCompanyService extends CrudServiceBaseTransformed<InsuranceCompanyDto> {
    constructor() {
        super(Endpoint.InsuranceCompany);
        this.internalHttp = httpApi;
    }

    public async create(createInsuranceCompanyInput: InsuranceCompanyDto) {
        isUserLoggedIn();

        let newCreateInsuranceCompanyInput = getPartialModel(createInsuranceCompanyInput, [], ['id', 'lastModifierUserId', 'lastModificationTime', 'creatorUserId', 'creationTime']);

        let result = await this.internalHttp.post(this.endpoint.Create(), newCreateInsuranceCompanyInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async update(updateInsuranceCompanyInput: InsuranceCompanyDto) {
        isUserLoggedIn();
        
        let newUpdateInsuranceCompanyInput = getPartialModel(updateInsuranceCompanyInput, [], ['lastModifierUserId', 'lastModificationTime', 'creatorUserId', 'creationTime']);

        let result = await this.internalHttp.put(this.endpoint.Update(), newUpdateInsuranceCompanyInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }
}

const exportInsuranceCompanyService: InsuranceCompanyService = new InsuranceCompanyService();
export default exportInsuranceCompanyService;